
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import PropTypes from "prop-types";
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { TitoAcceptCashout } from "../../../actions/terminal";

class CashIn extends Component {
    constructor (props) {
        super(props);
        this.cashIn = this.cashIn.bind(this);
    }

    cashIn () {
        return () => {
            let { data } = this.props.data;
            this.props.dispatch(TitoAcceptCashout({docId: data.barcode, amount: data.amount}));
            this.props.closePopup()();
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    let tid = JSON.parse(sessionStorage.getItem('authData')).tid;
    return createSelector(
        [
            state => state.swarmData.data.terminal_balance && state.swarmData.data.terminal_balance.terminals[tid] && state.swarmData.data.terminal_balance.terminals[tid].balance,
            state => state.user.depositMode,
        ],
        (terminalBalance, depositMode) => {
            return {
                terminalBalance,
                depositMode,
            };
        }
    );
};

CashIn.propTypes = {
    dara: PropTypes.object,
    closePopup: PropTypes.func,
    terminalBalance: PropTypes.number,
    depositMode: PropTypes.number,
};

export default connect(mapStateToProps)(UIMixin({Component: CashIn}));